import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/opposing-pitchers/actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class AllowOpposingPitchers extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.set('OpposingPitchersIsAllowed', isChecked));
    }

    render() {
        const {opposingPitchers} = this.props;
        return (
            <InputCheckbox
                label="Allow hitters vs opposing pitchers"
                checked={opposingPitchers.isAllowed()}
                onChange={::this.onChange}
            />
        );
    }
}

function mapStatesToProps(state) {
    return {
        opposingPitchers: state.opposingPitchers,
    };
}

export default connect(mapStatesToProps)(AllowOpposingPitchers);
